module.exports = {versao:  914 ,
old:true,
parceria:false,
url:"https://sec-api.aplicativogo.com.br/"};
